const routes = [
  {
    path: '',
    component: () => import('@/views/eden/childCount/Wrapper.vue'),
    children: [
      {
        path: '/eden/childcount',
        name: 'edenChildcount',
        component: () => import('@/views/eden/childCount/Main.vue'),
      },
      {
        path: '/eden/childcount/:id',
        name: 'edenChildCountDetails',
        component: () => import('@/views/eden/childCount/Details.vue'),
      },
    ],
  },
]

export default routes
